/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_103Inputs */

const vi_carrier_status_103 = /** @type {(inputs: Carrier_Status_103Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều phối bưu cục lấy hàng`)
};

/**

* @param {Carrier_Status_103Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_103 = /** @type {((inputs?: Carrier_Status_103Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_103Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_103(inputs)
});